import { Component, OnInit } from '@angular/core';
import { CustomerService } from 'src/app/services/customer.service';
import { InscripcionConvenioService } from 'src/app/services/inscripcion-convenio.service';

@Component({
  selector: 'app-seguimiento-planes-contratados',
  templateUrl: './seguimiento-planes-contratados.component.html',
  styleUrls: ['./seguimiento-planes-contratados.component.css']
})
export class SeguimientoPlanesContratadosComponent implements OnInit {
  public clientes: any[] = [];
  public clienteSeleccionado: any = null;
  public cargandoClientes = false;

  public suscripciones: any[] = [];
  public seguimientoCargado = false;
  public cargandoSeguimiento = false;
  public mensajeError = '';

  public periodoSeleccionado = '30';
  public periodos: any[] = [
    { id: '7', nombre: 'Última semana' },
    { id: '30', nombre: 'Último mes' },
    { id: '90', nombre: 'Últimos 3 meses' },
    { id: 'all', nombre: 'Todo el histórico' },
    { id: 'custom', nombre: 'Personalizado' }
  ];

  public fechaDesde = '';
  public fechaHasta = '';
  public fechaDesdeTemporal = '';
  public fechaHastaTemporal = '';
  public fechasPendientes = false;

  public tabSeleccionado = 'TODOS';
  public busqueda = '';
  public filtroMotivo = '';
  public filtroPlan = '';
  public filtroEjecutivo = '';

  public paginaActual = 1;
  public registrosPorPagina = 10;
  public ordenFechaAsc = false;

  public drawerAbierto = false;
  public suscripcionSeleccionada: any = null;

  constructor(
    public customerService: CustomerService,
    public inscripcionService: InscripcionConvenioService
  ) {}

  ngOnInit(): void {
    this.configurarPeriodoInicial();
    this.postListarCustomer();
  }

  public postListarCustomer(): void {
    this.cargandoClientes = true;
    this.mensajeError = '';

    this.customerService.postListarCustomer({})
      .then((data: any) => {
        this.clientes = Array.isArray(data) ? data : [];
        this.clienteSeleccionado = this.clientes.length > 0 ? this.clientes[0].cus_id : null;
        this.cargandoClientes = false;
      })
      .catch((error: any) => {
        console.error('[SeguimientoPlanesContratados] Error clientes:', error);
        this.clientes = [];
        this.clienteSeleccionado = null;
        this.cargandoClientes = false;

        if (error?.status === 403) this.mensajeError = 'Tu perfil no tiene permisos para consultar el listado de clientes.';
        else if (error?.status === 401) this.mensajeError = 'Tu sesión no está autorizada. Vuelve a iniciar sesión.';
        else this.mensajeError = 'No fue posible cargar los clientes.';
      });
  }

  private configurarPeriodoInicial(): void {
    this.periodoSeleccionado = '30';

    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);

    const desde = new Date(hoy);
    desde.setDate(desde.getDate() - 30);

    this.fechaDesde = this.formatearFechaInput(desde);
    this.fechaHasta = this.formatearFechaInput(hoy);
    this.fechaDesdeTemporal = this.fechaDesde;
    this.fechaHastaTemporal = this.fechaHasta;
    this.fechasPendientes = false;
  }

  public seleccionarPeriodo(periodo: string): void {
    this.mensajeError = '';

    if (periodo === 'custom') {
      this.periodoSeleccionado = 'custom';
      if (!this.fechaDesdeTemporal) this.fechaDesdeTemporal = this.fechaDesde;
      if (!this.fechaHastaTemporal) this.fechaHastaTemporal = this.fechaHasta;
      this.fechasPendientes = false;
      return;
    }

    this.periodoSeleccionado = periodo;

    if (periodo === 'all') {
      this.fechaDesde = '';
      this.fechaHasta = '';
      this.fechaDesdeTemporal = '';
      this.fechaHastaTemporal = '';
      this.fechasPendientes = false;

      if (this.seguimientoCargado) this.consultarSeguimiento();
      return;
    }

    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);

    const desde = new Date(hoy);
    desde.setDate(desde.getDate() - Number(periodo));

    this.fechaDesde = this.formatearFechaInput(desde);
    this.fechaHasta = this.formatearFechaInput(hoy);
    this.fechaDesdeTemporal = this.fechaDesde;
    this.fechaHastaTemporal = this.fechaHasta;
    this.fechasPendientes = false;

    if (this.seguimientoCargado) this.consultarSeguimiento();
  }

  public onClienteChange(): void {
    this.mensajeError = '';
    this.seguimientoCargado = false;
    this.suscripciones = [];
    this.resetFiltros();
  }

  public onFechaChange(): void {
    this.periodoSeleccionado = 'custom';
    this.fechasPendientes = true;
    this.mensajeError = '';
  }

  public aplicarFechas(): void {
    this.mensajeError = '';

    if (!this.fechaDesdeTemporal || !this.fechaHastaTemporal) {
      this.mensajeError = 'Debes seleccionar una fecha desde y una fecha hasta.';
      return;
    }

    if (this.fechaDesdeTemporal > this.fechaHastaTemporal) {
      this.mensajeError = 'La fecha desde no puede ser mayor a la fecha hasta.';
      return;
    }

    this.fechaDesde = this.fechaDesdeTemporal;
    this.fechaHasta = this.fechaHastaTemporal;
    this.periodoSeleccionado = 'custom';
    this.fechasPendientes = false;

    if (this.seguimientoCargado) this.consultarSeguimiento();
  }

  public verSeguimiento(): void {
    this.mensajeError = '';

    if (!this.clienteSeleccionado) {
      this.mensajeError = 'Debes seleccionar un cliente.';
      return;
    }

    if (this.periodoSeleccionado === 'custom' && this.fechasPendientes) {
      this.mensajeError = 'Debes aplicar el rango de fechas antes de continuar.';
      return;
    }

    if (this.periodoSeleccionado !== 'all' && (!this.fechaDesde || !this.fechaHasta)) {
      this.mensajeError = 'Debes seleccionar un período válido.';
      return;
    }

    if (this.fechaDesde && this.fechaHasta && this.fechaDesde > this.fechaHasta) {
      this.mensajeError = 'La fecha desde no puede ser mayor a la fecha hasta.';
      return;
    }

    this.consultarSeguimiento();
  }

  private consultarSeguimiento(): void {
    if (this.cargandoSeguimiento || !this.clienteSeleccionado) return;

    this.cargandoSeguimiento = true;
    this.mensajeError = '';

    const params = {
      cusBenCusId: String(this.clienteSeleccionado),
      subCarCreatedFrom: this.periodoSeleccionado === 'all' ? null : (this.fechaDesde || null),
      subCarCreatedTo: this.periodoSeleccionado === 'all' ? null : (this.fechaHasta || null)
    };

    console.log('[SeguimientoPlanesContratados] Parámetros:', params);

    this.inscripcionService.getListarSuscripciones(params)
      .then((data: any) => {
        if (Array.isArray(data)) this.suscripciones = data;
        else if (Array.isArray(data?.data)) this.suscripciones = data.data;
        else if (Array.isArray(data?.rows)) this.suscripciones = data.rows;
        else this.suscripciones = [];

        this.paginaActual = 1;
        this.tabSeleccionado = 'TODOS';
        this.busqueda = '';
        this.filtroMotivo = '';
        this.filtroPlan = '';
        this.filtroEjecutivo = '';
        this.seguimientoCargado = true;
        this.cargandoSeguimiento = false;

        console.log('[SeguimientoPlanesContratados] Suscripciones:', this.suscripciones);
      })
      .catch((error: any) => {
        console.error('[SeguimientoPlanesContratados] Error seguimiento:', error);

        this.suscripciones = [];
        this.seguimientoCargado = false;
        this.cargandoSeguimiento = false;

        if (error?.status === 403) this.mensajeError = 'Tu perfil no tiene permisos para consultar las suscripciones.';
        else if (error?.status === 401) this.mensajeError = 'Tu sesión no está autorizada. Vuelve a iniciar sesión.';
        else this.mensajeError = 'No fue posible cargar los planes contratados.';
      });
  }

  public seleccionarTab(tab: string): void {
    this.tabSeleccionado = tab;
    this.paginaActual = 1;
  }

  public onFiltroChange(): void {
    this.paginaActual = 1;
  }

  public resetFiltros(): void {
    this.tabSeleccionado = 'TODOS';
    this.busqueda = '';
    this.filtroMotivo = '';
    this.filtroPlan = '';
    this.filtroEjecutivo = '';
    this.paginaActual = 1;
  }

  public get suscripcionesFiltradas(): any[] {
    const texto = this.normalizarTexto(this.busqueda);

    let resultado = this.suscripciones.filter((item: any) => {
      const estado = this.getEstado(item);

      if (this.tabSeleccionado !== 'TODOS' && estado.toUpperCase() !== this.tabSeleccionado) return false;

      if (texto) {
        const nombre = this.normalizarTexto(item?.titular_nombre_completo);
        const rut = this.normalizarTexto(item?.use_rut);
        if (nombre.indexOf(texto) < 0 && rut.indexOf(texto) < 0) return false;
      }

      if (this.filtroMotivo && this.getMotivo(item) !== this.filtroMotivo) return false;
      if (this.filtroPlan && String(item?.cus_ben_id) !== String(this.filtroPlan)) return false;
      if (this.filtroEjecutivo && this.getEjecutivo(item) !== this.filtroEjecutivo) return false;

      return true;
    });

    resultado = resultado.slice().sort((a: any, b: any) => {
      const fechaA = this.getTimestamp(a?.fecha_actualizacion);
      const fechaB = this.getTimestamp(b?.fecha_actualizacion);
      return this.ordenFechaAsc ? fechaA - fechaB : fechaB - fechaA;
    });

    return resultado;
  }

  public get suscripcionesPaginadas(): any[] {
    const inicio = (this.paginaActual - 1) * this.registrosPorPagina;
    return this.suscripcionesFiltradas.slice(inicio, inicio + this.registrosPorPagina);
  }

  public get totalPaginas(): number {
    return Math.max(1, Math.ceil(this.suscripcionesFiltradas.length / this.registrosPorPagina));
  }

  public get paginasVisibles(): number[] {
    const paginas: number[] = [];
    let inicio = Math.max(1, this.paginaActual - 2);
    let fin = Math.min(this.totalPaginas, inicio + 4);

    if ((fin - inicio) < 4) inicio = Math.max(1, fin - 4);

    for (let i = inicio; i <= fin; i++) paginas.push(i);
    return paginas;
  }

  public irPagina(pagina: number): void {
    if (pagina < 1 || pagina > this.totalPaginas) return;
    this.paginaActual = pagina;
  }

  public toggleOrdenFecha(): void {
    this.ordenFechaAsc = !this.ordenFechaAsc;
    this.paginaActual = 1;
  }

  public get inicioRegistro(): number {
    if (this.suscripcionesFiltradas.length === 0) return 0;
    return ((this.paginaActual - 1) * this.registrosPorPagina) + 1;
  }

  public get finRegistro(): number {
    return Math.min(this.paginaActual * this.registrosPorPagina, this.suscripcionesFiltradas.length);
  }

  public get totalActivos(): number {
    return this.suscripciones.filter((item: any) => this.getEstado(item) === 'Activo').length;
  }

  public get totalSuspendidos(): number {
    return this.suscripciones.filter((item: any) => this.getEstado(item) === 'Suspendido').length;
  }

  public get totalCancelados(): number {
    return this.suscripciones.filter((item: any) => this.getEstado(item) === 'Cancelado').length;
  }

  public get tasaCancelacion(): number {
    if (!this.suscripciones.length) return 0;
    return Math.round((this.totalCancelados * 100) / this.suscripciones.length);
  }

  public get tieneDatosActividad(): boolean {
    return this.suscripciones.some((item: any) =>
      item?.use_datos_completed !== undefined &&
      item?.use_datos_completed !== null
    );
  }

  public get totalTitularesSinActividad(): number {
    return this.suscripciones.filter(
      (item: any) => item?.use_datos_completed === false
    ).length;
  }

  public get planesDisponibles(): any[] {
    const map: any = {};

    this.suscripciones.forEach((item: any) => {
      if (item?.cus_ben_id !== null && item?.cus_ben_id !== undefined) {
        map[String(item.cus_ben_id)] = item.plan_nombre || ('Plan ' + item.cus_ben_id);
      }
    });

    return Object.keys(map)
      .map((id: string) => ({ id, nombre: map[id] }))
      .sort((a: any, b: any) => a.nombre.localeCompare(b.nombre));
  }

  public get motivosDisponibles(): string[] {
    const valores: string[] = [];

    this.suscripciones.forEach((item: any) => {
      const motivo = this.getMotivo(item);
      if (motivo !== '—' && valores.indexOf(motivo) < 0) valores.push(motivo);
    });

    return valores.sort();
  }

  public get ejecutivosDisponibles(): string[] {
    const valores: string[] = [];

    this.suscripciones.forEach((item: any) => {
      const ejecutivo = this.getEjecutivo(item);
      if (ejecutivo && valores.indexOf(ejecutivo) < 0) valores.push(ejecutivo);
    });

    return valores.sort();
  }

  public getEstado(item: any): string {
    return item?.estado_plan || 'Activo';
  }

  public getMotivo(item: any): string {
    return item?.motivo || '—';
  }

  public getEjecutivo(item: any): string {
    if (item?.ejecutivo) return item.ejecutivo;

    if (this.getTipoContratacion(item) === 'Directa') {
      return 'Contratación directa';
    }

    return item?.sub_car_seller_name || 'Sin ejecutivo';
  }

  public getTipoContratacion(item: any): string {
    const tipo = String(item?.tipo_contratacion || '').trim().toUpperCase();

    if (tipo === 'DIRECTA') return 'Directa';
    if (tipo === 'ASISTIDA') return 'Asistida';

    const origen = String(item?.sub_car_origin || '').trim().toUpperCase();

    if (origen === 'PATIENT') return 'Directa';
    if (origen) return 'Asistida';

    return '—';
  }

  public getTipoPlan(item: any): string {
    if (item?.tipo_plan) return item.tipo_plan;
    if (item?.cus_ben_particular === true) return 'Particular';
    if (item?.cus_ben_particular === false) return 'Corporativo';
    return '—';
  }

  public getEstadoClase(item: any): string {
    const estado = this.getEstado(item);

    if (estado === 'Activo') return 'estado-activo';
    if (estado === 'Suspendido') return 'estado-suspendido';
    if (estado === 'Cancelado') return 'estado-cancelado';

    return 'estado-neutral';
  }

  public getMotivoClase(item: any): string {
    const motivo = this.normalizarTexto(this.getMotivo(item));

    if (motivo.indexOf('pago') >= 0 || motivo.indexOf('cancel') >= 0) return 'motivo-rojo';
    if (motivo === '—') return '';

    return 'motivo-neutral';
  }

  public getValorMensual(item: any): number {
    const titular = Number(item?.valor_mensual_titular || 0);
    const carga1 = Number(item?.valor_mensual_carga1 || 0);
    const carga2 = Number(item?.valor_mensual_carga2 || 0);
    const cantidad = Number(item?.cantidad_beneficiarios || 0);

    if (cantidad <= 0) return titular;
    if (cantidad === 1) return titular + carga1;

    return titular + carga1 + ((cantidad - 1) * carga2);
  }

  public formatearMonto(valor: any): string {
    const numero = Number(valor || 0);

    return '$' + numero.toLocaleString('es-CL', {
      maximumFractionDigits: 0,
      minimumFractionDigits: 0
    });
  }

  public formatearRut(rut: any): string {
    if (!rut) return '—';

    const valor = String(rut).replace(/\./g, '').replace(/-/g, '').trim();

    if (valor.length < 2) return valor;

    const cuerpo = valor.substring(0, valor.length - 1);
    const dv = valor.substring(valor.length - 1);
    let resultado = '';
    let contador = 0;

    for (let i = cuerpo.length - 1; i >= 0; i--) {
      resultado = cuerpo.charAt(i) + resultado;
      contador++;

      if (contador === 3 && i !== 0) {
        resultado = '.' + resultado;
        contador = 0;
      }
    }

    return resultado + '-' + dv;
  }

  public abrirDetalle(item: any): void {
    this.suscripcionSeleccionada = item;
    this.drawerAbierto = true;
  }

  public cerrarDetalle(): void {
    this.drawerAbierto = false;
    this.suscripcionSeleccionada = null;
  }

  public getPersonasPlan(item: any): any[] {
    if (!item) return [];

    const personas: any[] = [{
      ben_id: item.ben_id,
      use_id: item.use_id,
      rut: item.use_rut,
      nombre_completo: item.titular_nombre_completo,
      email: item.use_email,
      telefono: item.telefono,
      tipo: 'Titular',
      use_datos_completed: item.use_datos_completed,
      acceso_plataforma: item.acceso_plataforma,
      ultima_consulta: item.ultima_consulta
    }];

    const beneficiarios = Array.isArray(item?.beneficiarios)
      ? item.beneficiarios
      : [];

    beneficiarios.forEach((beneficiario: any) => {
      personas.push({
        ...beneficiario,
        tipo: 'Beneficiario'
      });
    });

    return personas;
  }

  public getAccesoPersona(persona: any): string {
    if (persona?.acceso_plataforma) {
      return persona.acceso_plataforma;
    }

    return persona?.use_datos_completed === true
      ? 'Ingresó'
      : 'Nunca ingresó';
  }

  public getAccesoClase(persona: any): string {
    return persona?.use_datos_completed === true
      ? 'acceso-si'
      : 'acceso-no';
  }

  public getUltimaConsulta(persona: any): string {
    if (!persona?.ultima_consulta) return '—';
    return this.formatearFechaVista(persona.ultima_consulta);
  }

  public getContactoPersona(persona: any): string {
    return persona?.telefono || persona?.email || '—';
  }

  public getEspecialidades(item: any): any[] {
    return Array.isArray(item?.especialidades) ? item.especialidades : [];
  }

  public getCantidadConsultasEspecialidad(especialidad: any): string {
    const valor = especialidad?.cantidad_consultas_titular;

    if (valor === null || valor === undefined || valor === '') return '—';

    return String(valor);
  }

  public getHistorialVisual(item: any): any[] {
    const historial: any[] = [];

    if (!item) return historial;

    if (item?.fecha_contratacion) {
      historial.push({
        titulo: 'Plan activo',
        fecha: item.fecha_contratacion,
        tipo: 'activo'
      });
    }

    const estado = this.getEstado(item);

    if (estado !== 'Activo' && item?.fecha_actualizacion) {
      historial.push({
        titulo: estado + (this.getMotivo(item) !== '—' ? ' - ' + this.getMotivo(item) : ''),
        fecha: item.fecha_actualizacion,
        tipo: estado === 'Cancelado' ? 'cancelado' : 'suspendido'
      });
    }

    return historial;
  }

  public get nombrePeriodoSeleccionado(): string {
    const periodo = this.periodos.find((item: any) => item.id === this.periodoSeleccionado);
    return periodo ? periodo.nombre : '';
  }

  public get resumenPeriodo(): string {
    if (this.periodoSeleccionado === 'all') return 'Mostrando todo el histórico';
    if (!this.fechaDesde || !this.fechaHasta) return '';

    return 'Mostrando ' + this.nombrePeriodoSeleccionado + ' · ' +
      this.formatearFechaVista(this.fechaDesde) + ' – ' +
      this.formatearFechaVista(this.fechaHasta);
  }

  public get clienteSeleccionadoData(): any {
    if (!this.clienteSeleccionado) return null;

    return this.clientes.find(
      (cliente: any) => Number(cliente?.cus_id) === Number(this.clienteSeleccionado)
    ) || null;
  }

  public get clienteNombreSeleccionado(): string {
    return this.clienteSeleccionadoData?.cus_name || '';
  }

  public get totalSuscripciones(): number {
    return this.suscripciones.length;
  }

  public exportarCSV(): void {
    if (!this.suscripcionesFiltradas.length) return;

    const filas = this.suscripcionesFiltradas.map((item: any) => [
      item?.titular_nombre_completo || '',
      item?.use_rut || '',
      item?.plan_nombre || '',
      this.getEstado(item),
      this.getMotivo(item),
      this.formatearFechaVista(item?.fecha_contratacion),
      this.formatearFechaVista(item?.fecha_actualizacion),
      this.getTipoContratacion(item),
      this.getEjecutivo(item),
      this.getAccesoPersona(item),
      item?.telefono || '',
      item?.use_email || ''
    ]);

    const encabezado = [
      'Titular',
      'RUT',
      'Plan',
      'Estado',
      'Motivo',
      'Fecha contratación',
      'Cambio de estado',
      'Tipo contratación',
      'Ejecutivo',
      'Acceso plataforma',
      'Teléfono',
      'Email'
    ];

    const contenido = [encabezado, ...filas]
      .map((fila: any[]) =>
        fila.map((valor: any) => '"' + String(valor || '').replace(/"/g, '""') + '"').join(';')
      )
      .join('\n');

    const blob = new Blob(['\ufeff' + contenido], {
      type: 'text/csv;charset=utf-8;'
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.download = 'seguimiento_planes_contratados.csv';
    link.click();

    URL.revokeObjectURL(url);
  }

  private formatearFechaInput(fecha: Date): string {
    const year = fecha.getFullYear();
    const month = ('0' + (fecha.getMonth() + 1)).slice(-2);
    const day = ('0' + fecha.getDate()).slice(-2);

    return year + '-' + month + '-' + day;
  }

  public formatearFechaVista(fecha: any): string {
    if (!fecha) return '—';

    const valor = String(fecha).substring(0, 10);
    const partes = valor.split('-');

    if (partes.length !== 3) return String(fecha);

    return partes[2] + '-' + partes[1] + '-' + partes[0];
  }

  private getTimestamp(fecha: any): number {
    if (!fecha) return 0;

    const timestamp = new Date(fecha).getTime();

    return isNaN(timestamp) ? 0 : timestamp;
  }

  private normalizarTexto(valor: any): string {
    return String(valor || '')
      .toLowerCase()
      .trim()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }
}